import type { ReactNode } from 'react'

interface SectionHeaderProps {
  /** UPPERCASE-tracked eyebrow — short, no parent-page repeat. */
  label: string
  /** Optional count or contextual hint. */
  count?: number | string
  /** Right-aligned actions. */
  actions?: ReactNode
}

/**
 * Group header inside a page. NEVER use as a page title. See DESIGN.md § 9.
 *
 *   <SectionHeader label="Pausenregeln" count={3} />
 */
export function SectionHeader({ label, count, actions }: SectionHeaderProps) {
  return (
    <div className="flex items-baseline justify-between mb-3">
      <h3 className="text-[10px] font-black uppercase tracking-widest text-on-surface-variant">
        {label}
        {count !== undefined && <span className="text-on-surface-variant font-normal ml-1.5">({count})</span>}
      </h3>
      {actions}
    </div>
  )
}
